import { Button, Spin } from 'antd';
import React, { useEffect } from 'react';
import { isEmpty } from 'underscore';
import styles from '../Style/AnalyticsPanel.module.scss';
import { IPreprocessedAnalyticsPayload } from '../../../../types/chart';
import { DownloadOutlined } from '@ant-design/icons';
import { IReport } from '../../../../types/api';

export default function Reports(props: {
  coordinates: number[];
  previewDatasetId: string;
  onUpdate: (payload: IPreprocessedAnalyticsPayload) => void;
  links: Array<IReport>;
  error: string;
  updating: boolean;
  waterDepth: string;
}) {
  const { previewDatasetId, coordinates, onUpdate, links, updating, error, waterDepth } =
    props;
  const title = 'Pre-processed Analytics';

  useEffect(() => {
    if (previewDatasetId && !isEmpty(coordinates)) {
      const [longitude, latitude] = coordinates;

      const payload: IPreprocessedAnalyticsPayload = {
        Longitude: longitude.toString(),
        Latitude: latitude.toString(),
        DatasetId: previewDatasetId,
        WaterDepth: waterDepth,
      };
      onUpdate(payload);
    }
  }, [previewDatasetId, coordinates]);

  const getLinks = (links: Array<IReport>) => {
    return (
      <div className={styles.reportsContainer}>
        {links.map((link: IReport, index: number) => {
          return link.Link ? (
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              size="small"
              key={index}
              className={styles.preprocessedLink}
              href={link.Link}
            >
              {link.DisplayName}
            </Button>
          ) : null;
        })}
      </div>
    );
  };

  return (
    <div>
      <div className={styles.reportsTitle}>{title}</div>
      {updating ? (
        <div className={styles.spinner}>
          <Spin size="large" />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : links ? (
        getLinks(links)
      ) : null}
    </div>
  );
}
